<template>
  <div class="vue_body_min_height" style="padding-bottom: 50px;">
    <img v-if="currentBanner != null" :src="currentBanner.url" style="width: 100%;">
    <div id="basketball_matches_outer" class="container">

      <div class="row" v-if="false">
        <div class="col-xs-12 col-md-5" style="margin-top: 50px;">
          <div class="matches-blank-head">本月赛事</div>
          <div class="matches-blank-body" style="padding: 20px 0 30px 0;">
            <div v-for="(item, index) in monthMatchesList" class="month-match-item">
              <a href="#" style="text-decoration: none;">
                <div class="month-match-item-title" >
                <span class="iconfont" style="margin-right: 15px;color: #fc1a34;">&#xe7e3;</span>{{item.title}}</div>
                <div class="month-match-item-desc">比赛日期：{{item.desc}}</div>
              </a>
            </div>

          </div>
        </div>
        <div class="col-xs-12 col-md-7" style="margin-top: 50px;">
          <div class="matches-blank-head">赛程中心</div>
          <div class="matches-blank-body" id="match_center_content">
            <div :class="[centerCardClass]" v-for="num in 4">
              <match-item-card />
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12" style="margin-top: 50px;">

          <a href="javascript:void (null);"
             v-for="(item, index) in tabList"
             :class="['matches-blank-head', tabIndex == index ? 'active' : '']"
             v-text="item"
             @click="tabMenuClicked(index)"
          ></a>
          <div class="matches-blank-body">

            <match-bottom-card v-for="(item, index) in matchList" :key="'match_card_' + index" :item="item" />

            <div style="clear: both;"></div>

            <div id="matches_items_paginator" style="text-align: right">
              <a href="javascript:void(null);" @click="leftButtonClicked" class="iconfont">&#xe663;</a>
              <span><a href="javascript:void(null);" @click="pageButtonClicked">{{pageIndex}}</a>/{{totalPage}}</span>
              <a href="javascript:void(null);" @click="rightButtonClicked" class="iconfont">&#xe611;</a>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MatchItemCard from "../components/matches/MatchItemCard";
import MatchBottomCard from "../components/matches/MatchBottomCard";
export default {
  name: "BasketballMatchesPage",
  components: {
    MatchItemCard,
    MatchBottomCard
  },
  data() {
    return {
      title: '篮球赛事',
      tabIndex: 0,
      tabList: [
        '全部赛事',
        // '校园赛事'
      ],
      monthMatchesList: [
        {
          title: '上海市中小学生篮球冠军赛',
          id:'matches_001',
          desc: '2020年12月1日-2020年12月31日',
        },
        {
          title: '上海市中小学生篮球冠军赛',
          id:'matches_001',
          desc: '2020年12月1日-2020年12月31日',
        },
        {
          title: '上海市中小学生篮球冠军赛',
          id:'matches_001',
          desc: '2020年12月1日-2020年12月31日',
        },
      ],
      qualityMatchesList: [],
      matchCenterValue1: false,


      matchList: null,

      pageIndex: 1,
      size: 10,
      isLoading: false,
      count: 0,
    }
  },
  mounted() {
    this.loadData();
    this.updateStatus();
    $(window).resize(this.updateStatus);

    let shareObj = this.$store.state.http.defaultShareObj;
    shareObj.title = '篮球赛事';
    shareObj.link = location.href;
    this.configShareWx(encodeURIComponent(location.href), shareObj);
  },
  computed: {
    banners() {
      return this.$store.state.banners;
    },
    currentBanner() {
      if (this.banners == null) {
        return null;
      }
      let item = this.banners.find(function (item) {
        return  item.name == 'matches';
      });

      if (item == undefined) {
        return null;
      }
      return item;
    },

    centerCardClass() {
      return this.matchCenterValue1 ? 'match-center-card-outer-50' : 'match-center-card-outer-100';
    },
    totalPage() {
      let total = 0;
      if (this.count == 0) {
        total = 0;
      } else {
        total = Math.ceil(this.count / this.size);
      }
      return total;
    },
  },
  methods: {
    tabMenuClicked(index) {
      this.tabIndex = index;
    },
    updateStatus() {
      let width = $('#match_center_content').width();
      if (width >= 580) {
        this.matchCenterValue1 = true;
      } else {
        this.matchCenterValue1 = false;
      }
    },
    loadData() {
      if (this.isLoading) {
        return;
      }
      let pageIndex = this.pageIndex;
      this.isLoading = true;
      let params = {
        pageIndex,
        size: this.size
      }
      let _this = this;
      this.$store.state.http.ajax.vmMatch(params, function (data) {
        _this.isLoading = false;
        let code = data.code;
        if (code == 0) {
          _this.count = data.count;
          let list = data.data;
          _this.matchList = list;
          return;
        }

        if (pageIndex > 1) {
          pageIndex --;
          _this.pageIndex = pageIndex;
          _this.$toast('请求失败！');
        }

      }, function (data) {
        if (pageIndex > 1) {
          pageIndex --;
          _this.pageIndex = pageIndex;
        }
        _this.isLoading = false;
        _this.$toast('请求失败，请重试！');
      });
    },
    leftButtonClicked() {
      let index = this.pageIndex;
      index --;
      if (index >= 1) {
        this.pageIndex = index;
        this.loadData();
      }
    },
    rightButtonClicked() {
      let index = this.pageIndex;
      index ++;
      if (index <= this.totalPage) {
        this.pageIndex = index;
        this.loadData();
      }
    },
    pageButtonClicked() {
      this.loadData();
    }

  }
}
</script>

<style scoped>
  #basketball_matches_outer {

  }

  .matches-blank-head {
    background-color: #fc1a34;
    color: white;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    font-size: 2rem;
    padding: 6px 4vw;
    text-align: center;
    font-weight: bold;
    display: inline-block;
  }

  a.matches-blank-head {
    background-color: white;
    border: solid 1px #fc1a34;
    font-weight: normal;
    text-decoration: none;
    color: #333;
  }

  .matches-blank-head:not(:first-child) {
    margin-left: 3px;
  }

  a.matches-blank-head.active, a.matches-blank-head:hover {
    background-color: #fc1a34;
    font-weight: bold;
    color: white;
  }

  a.matches-blank-head.active {
    pointer-events: none;
  }

  .matches-blank-body {
    border: solid 1px #fc1a34;
    width: 100%;
    padding-left: 15px;
    padding-right: 15px;
    padding-bottom: 20px;
  }
  .month-match-item {
    margin-top: 10px;
    padding: 5px 15px;
    box-shadow: 0 0 4px #eeeeee;
  }

  .month-match-item-title {
    font-size: 1rem;
    font-weight: bold;
    color: #333;
  }
  .month-match-item-desc {
    margin-top: 5px;
    font-size: 0.8rem;
    color: #999;
  }

  #match_center_content {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 0;

  }


  #match_center_content > div {
    padding: 15px 0;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .match-center-card-outer-100 {
    width: 100%
  }

  .match-center-card-outer-50 {
    width: 50%;
  }

  #matches_items_paginator {
    padding-right: 30px;
    margin-top: 30px;
  }

  #matches_items_paginator a {
    color: #fc1a34;
    font-size: 1.5rem;
    text-decoration: none;
  }

</style>



// WEBPACK FOOTER //
// src/pages/BasketballMatchesPage.vue